<div
  #readContainer
  kendoDialogContainer
  class="h-[calc(100vh-2rem)] w-full flex flex-col gap-2 p-2 pb-20 bg-neutral-10 main-page scrollbar"
  [class]="
    onboardingStore.inProgress()
      ? 'pointer-events-none overflow-hidden pb-32'
      : ''
  "
>
  @if (loading.saveEmail) {
    <maximizer-loader type="legacy"></maximizer-loader>
  }

  <!-- Save to Entry Search -->
  <!-- Wrapped so the zero-height popover anchor does not claim a flex gap -->
  <div>
    <!-- Onboarding anchor | Step 2: Guide 2  -->
    <div
      kendoPopoverContainer
      [popover]="saveEmail2"
      #saveEmail2Anchor
      #saveEmail2Container="kendoPopoverContainer"
      showOn="none"
    ></div>
    <div
      class="transition-all border-2 border-transparent rounded"
      [class.border-pulse-enter]="
        onboardingStore.inProgress() &&
        onboardingStore.currentGuide() === StepGuideId.SaveEmail2
      "
      [class.pointer-events-auto]="
        onboardingStore.inProgress() &&
        onboardingStore.currentStep() === OnboardingStepNumber.Step2
      "
    >
      <maximizer-outlook-entry-search
        [entryActions]="buildSaveEmailActions"
        [disabled]="
          onboardingStore.inProgress() &&
          onboardingStore.currentGuide() !== StepGuideId.SaveEmail2
        "
        [restoreSearchOnLoad]="!onboardingStore.inProgress()"
        (searchActiveChange)="searchActive.set($event)"
      ></maximizer-outlook-entry-search>
    </div>
  </div>

  @if (!searchActive()) {
    <span
      kendoTooltip
      class="flex flex-col gap-2"
      filter="[title]"
      [callout]="false"
      [showAfter]="500"
      kendoTooltipWidth="auto"
      [tooltipTemplate]="tooltipTemplate"
    >
      <!-- Not In Maximizer -->
      <!-- Wrapped so the zero-height popover anchor does not claim a flex gap -->
      <div>
        <!-- Onboarding anchor | Step 1: Guide 1 -->
        <div
          kendoPopoverContainer
          [popover]="addContact1"
          #addContact1Anchor
          #addContact1Container="kendoPopoverContainer"
          showOn="none"
        ></div>
        <maximizer-outlook-not-in-maximizer-list
          [entries]="notInMaximizer"
          [pagerSettings]="pagerSettingsNotInMax"
          [pageSize]="pageSize"
          [loading]="loading.skeleton"
          [addEntryMenuItems]="addEntryMenuItems"
          [onboardingInProgress]="onboardingStore.inProgress()"
          [currentGuide]="onboardingStore.currentGuide()"
          [currentStep]="onboardingStore.currentStep()"
          [inMaximizerLength]="inMaximizer.length"
          (addEntry)="onAddEntry($event)"
          (addEntryDropDownOpen)="openAddEntryDropDown()"
          (addEntryDropDownClose)="closeAddEntryDropDown()"
        ></maximizer-outlook-not-in-maximizer-list>
      </div>

      <!-- In Maximizer -->
      <!-- Wrapped so the zero-height popover anchors do not claim flex gaps -->
      <div>
        <!-- Onboarding anchor | Step 2: Guide 1  -->
        <div
          kendoPopoverContainer
          [popover]="saveEmail1"
          #saveEmail1Anchor
          #saveEmail1Container="kendoPopoverContainer"
          showOn="none"
        ></div>
        <!-- Onboarding anchor | Step 3: Guide 1  -->
        <div
          kendoPopoverContainer
          [popover]="entryActions1"
          #entryActions1Anchor
          #entryActions1Container="kendoPopoverContainer"
          showOn="none"
        ></div>
        <maximizer-outlook-in-maximizer-list
          [entries]="inMaximizer"
          [dataResult]="inMaximizerDataResult"
          [state]="state"
          [pagerSettings]="pagerSettingsInMax"
          [loading]="loading"
          [disableSaveAll]="disableSaveEmailAllEntries"
          [saveAllTooltip]="
            getInMaximizerPermission()
              ? disableSaveEmailAllEntries
                ? ('outlook.main.tooltip.email-saved-all' | translate)
                : ('outlook.main.tooltip.save-email-all' | translate)
              : getSaveAllPermissionMessage()
          "
          [saveAllDisabled]="
            disableSaveEmailAllEntries ||
            !getInMaximizerPermission() ||
            (onboardingStore.inProgress() &&
              onboardingStore.currentStep() !== OnboardingStepNumber.Step2)
          "
          [onboardingInProgress]="onboardingStore.inProgress()"
          [currentGuide]="onboardingStore.currentGuide()"
          [currentStep]="onboardingStore.currentStep()"
          [entryActionsGuideVisible]="entryActionsGuideVisible()"
          [userRights]="userRights"
          [userEmails]="outlookStore.userEmails()"
          [autoSaveEnabledIds]="autoSaveEnabledList"
          (pageChange)="inMaximizerPageChange($event)"
          (saveAll)="saveEmailForAllEntries()"
          (navigateEntry)="onNavigateEntry($event)"
          (saveEntry)="onSaveEntry($event)"
        ></maximizer-outlook-in-maximizer-list>
      </div>
    </span>

    <!-- Related Opportunity/Case -->
    @if (!onboardingStore.inProgress() && showRelatedSection) {
      <button
        id="outlook-main-ui-read-related"
        class="text-bush-green-140 bg-white rounded p-3 flex justify-between items-center border-2 border-transparent hover:bg-bush-green-15 hover:cursor-pointer text-left"
        type="button"
        (click)="navigateToRelated()"
        [disabled]="loading.skeleton"
      >
        <p class="subtitle-2">{{ relatedTitle }}</p>
        <span class="fa-icons icon-14 icon-chevron-right mx-2"></span>
      </button>
    }

    <!-- Saved to others in Maximizer -->
    @if (otherInMaximizer.length > 0 && !loading.skeleton) {
      <div class="py-2 px-1.5 bg-white rounded border-2 border-transparent">
        <p class="subtitle-2 py-1 px-1.5">
          {{
            'outlook.main.savedToOthers'
              | translate: { count: otherInMaximizer.length }
          }}
        </p>
        <div
          kendoTooltip
          filter="[title]"
          [callout]="false"
          [showAfter]="500"
          kendoTooltipWidth="auto"
          [tooltipTemplate]="tooltipTemplate"
        >
          <kendo-listview
            [kendoListViewBinding]="otherInMaximizer"
            class="border-none"
          >
            <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
              <!-- No currentGuide/inMaximizerLength: these rows are outside the
                   onboarding guides, so they must never take a step highlight.
                   The remaining onboarding inputs keep them locked mid-guide. -->
              <maximizer-outlook-read-entry-row
                [entry]="dataItem"
                [canNavigate]="true"
                [isFromPopup]="true"
                [onboardingInProgress]="onboardingStore.inProgress()"
                [currentStep]="onboardingStore.currentStep()"
                [entryActionsGuideVisible]="entryActionsGuideVisible()"
                [userRights]="userRights"
                [userEmails]="outlookStore.userEmails()"
                [autoSaveEnabledIds]="autoSaveEnabledList"
                (navigate)="onNavigateEntry($event)"
                (save)="onSaveEntry($event)"
              ></maximizer-outlook-read-entry-row>
            </ng-template>
          </kendo-listview>
        </div>
      </div>
    }
  }
</div>

<ng-template #tooltipTemplate let-anchor>
  <p class="caption text-center text-neutral-90 whitespace-nowrap">
    {{ anchor.nativeElement.getAttribute('data-title') }}
  </p>
</ng-template>

<maximizer-outlook-notification
  entryId="entries"
  #notification
  [closable]="true"
></maximizer-outlook-notification>

@if (saveEmailDetail) {
  <maximizer-email-detail
    [emailProperties]="saveEmailDetailProperties"
    [saveFromPopup]="isSavingFromPopup"
    [saveToAll]="saveToAll"
    (saveEmail)="onSaveEmailDetail($event)"
    (closed)="this.saveEmailDetail = false"
  ></maximizer-email-detail>
}

<!-- Onboarding -->
<!-- Step 1: Guide 1  -->
<kendo-popover
  #addContact1
  position="bottom"
  [width]="stepPopoverWidth"
  [offset]="
    notInMaximizer.length > 0
      ? OnboardingGuideOffsets.ADD_CONTACT_1
      : OnboardingGuideOffsets.ADD_CONTACT_1_ALT
  "
>
  <ng-template kendoPopoverBodyTemplate>
    <maximizer-outlook-onboarding-step-guide
      [onboardingStep]="1"
      [guide]="
        notInMaximizer.length > 0
          ? onboardingStore.getGuideForStep(StepGuideId.AddContact1)
          : onboardingStore.getGuideForStep(StepGuideId.AddContact1Alt)
      "
      (exit)="onboardingService.showExitDialog.set(true)"
      (next)="nextOnboardingStep($event)"
    ></maximizer-outlook-onboarding-step-guide>
  </ng-template>
</kendo-popover>

<!-- Step 2: Guide 1 -->
<kendo-popover
  #saveEmail1
  [position]="popoverPosition"
  [width]="stepPopoverWidth"
  [offset]="
    inMaximizer.length > 0 && popoverPosition === 'bottom'
      ? OnboardingGuideOffsets.SAVE_EMAIL_1
      : OnboardingGuideOffsets.SAVE_EMAIL_1_ALT
  "
>
  <ng-template kendoPopoverBodyTemplate>
    <maximizer-outlook-onboarding-step-guide
      [onboardingStep]="2"
      [guide]="
        inMaximizer.length > 0
          ? onboardingStore.getGuideForStep(StepGuideId.SaveEmail1)
          : onboardingStore.getGuideForStep(StepGuideId.SaveEmail1Alt)
      "
      (exit)="onboardingService.showExitDialog.set(true)"
      (next)="nextOnboardingGuide(StepGuideId.SaveEmail1)"
    ></maximizer-outlook-onboarding-step-guide>
  </ng-template>
</kendo-popover>

<!-- Step 2: Guide 2 -->
<kendo-popover
  #saveEmail2
  position="bottom"
  [width]="stepPopoverWidth"
  [offset]="OnboardingGuideOffsets.SAVE_EMAIL_2"
>
  <ng-template kendoPopoverBodyTemplate>
    <maximizer-outlook-onboarding-step-guide
      [onboardingStep]="2"
      [guide]="onboardingStore.getGuideForStep(StepGuideId.SaveEmail2)"
      (exit)="onboardingService.showExitDialog.set(true)"
      (next)="nextOnboardingStep($event)"
    ></maximizer-outlook-onboarding-step-guide>
  </ng-template>
</kendo-popover>

<!-- Step 3: Guide 1 -->
<kendo-popover
  #entryActions1
  [position]="popoverPosition"
  [width]="stepPopoverWidth"
  [offset]="
    inMaximizer.length > 0 && popoverPosition === 'bottom'
      ? OnboardingGuideOffsets.ENTRY_ACTIONS_1
      : OnboardingGuideOffsets.ENTRY_ACTIONS_1_ALT
  "
>
  <ng-template kendoPopoverBodyTemplate>
    <maximizer-outlook-onboarding-step-guide
      [onboardingStep]="3"
      [guide]="
        inMaximizer.length > 0
          ? onboardingStore.getGuideForStep(StepGuideId.EntryActions1)
          : onboardingStore.getGuideForStep(StepGuideId.EntryActions1Alt)
      "
      (exit)="onboardingService.showExitDialog.set(true)"
      (next)="nextOnboardingStep($event)"
    ></maximizer-outlook-onboarding-step-guide>
  </ng-template>
</kendo-popover>
